module.exports = __webpack_public_path__ + "img/plan-1-3.5d8772fc.png";